import styled from 'styled-components';
import { vars } from '@agendor/ui';

export const FormGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const InputGroup = styled.label`
    display: flex;
    flex-direction: column;
    gap: 6px;
    font-weight: 600;
    font-size: 0.95rem;
    color: ${vars.foregroundColor};
`;

export const LabelRow = styled.div`
    display: flex;
    align-items: baseline;
    justify-content: space-between;
`;

export const OptionalBadge = styled.span`
    font-weight: 400;
    color: #888;
    font-size: 0.85em;
`;

export const HelperText = styled.span`
    font-size: 0.85rem;
    font-weight: 400;
    color: #666;
    margin-top: -2px;
`;

export const Select = styled.select`
    width: 100%;
    box-sizing: border-box;
    padding: 8px 24px 8px 12px;
    border: 1px solid ${vars.dividerColor};
    border-radius: 6px;
    font: inherit;
    color: ${vars.foregroundColor};
    -webkit-text-fill-color: ${vars.foregroundColor};
    background-color: rgb(255, 255, 255);
    appearance: none;
    background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="10" height="6"><path fill="${encodeURIComponent(
        vars.foregroundColor,
    )}" d="M0 0l5 6 5-6z"/></svg>');
    background-repeat: no-repeat;
    background-position: calc(100% - 12px) 50%;

    &:disabled {
        background-color: rgba(0, 0, 0, 0.05);
        color: #666;
        cursor: not-allowed;
        -webkit-text-fill-color: #666;
    }
`;

export const TextArea = styled.textarea`
    width: 100%;
    box-sizing: border-box;
    padding: 8px 12px;
    border: 1px solid ${vars.dividerColor};
    border-radius: 6px;
    font: inherit;
    background-color: rgb(255, 255, 255);
    resize: vertical;
    min-height: 96px;

    &:disabled {
        background-color: rgba(0, 0, 0, 0.05);
        color: #666;
        cursor: not-allowed;
    }
`;

export const Checkbox = styled.input.attrs({ type: 'checkbox' })`
    width: 18px;
    height: 18px;
    flex-shrink: 0;
    border: 1px solid ${vars.dividerColor};
    border-radius: 4px;
    margin-top: 2px;
`;

export const CheckboxLabel = styled.label`
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 0.95rem;
    color: ${vars.foregroundColor};
    cursor: pointer;
    user-select: none;
    width: fit-content;

    /* A label whose box can't be clicked must not offer to be clicked. */
    &:has(input:disabled) {
        cursor: default;
        color: #666;
    }
`;

export const Divider = styled.hr`
    border: none;
    border-top: 1px solid ${vars.dividerColor};
    margin: 8px 0;
    width: 100%;
`;

export const CheckboxGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 8px 0;
`;

export const WarningBanner = styled.div<{ $severity?: 'info' | 'warning' | 'error' }>`
    padding: 12px 14px;
    border-radius: 8px;
    font-size: 0.85rem;
    line-height: 1.4;
    background-color: ${(p) =>
        p.$severity === 'error'
            ? vars.dangerTintSoft
            : p.$severity === 'info'
              ? vars.primaryColorLight
              : vars.warningTintSoft};
    color: ${(p) => (p.$severity === 'error' ? vars.dangerColor : vars.foregroundColor)};
    border: 1px solid ${(p) => (p.$severity === 'error' ? vars.dangerTint : vars.dividerColor)};
`;
